<button
  data-test="gPDeNVfy"
  class="button"
  [disabled]="disabled"
  (click)="handleClick($event)"
  [ngClass]="classes"
>
  <ng-container *ngIf="iconLeft">
    <span data-test="RXZG8wGt" class="button__icon button__icon_left">
      <i data-test="5awa5033" class="material-icons">{{ iconLeft }}</i>
    </span>
  </ng-container>
  <ng-content></ng-content>
  <ng-container *ngIf="iconRight">
    <span data-test="9cLpelFU" class="button__icon button__icon_right">
      <i data-test="pE2f2Wz-" class="material-icons">{{ iconRight }}</i>
    </span>
  </ng-container>
</button>
